"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _purchaseOrder = require("@/api/member/purchaseOrder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: '',
  props: {
    memberId: {
      type: Number,
      default: null
    },
    callbackQueryData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      queryData: {
        type: 0,
        orderNo: '',
        platform: '',
        status: null,
        violate: null,
        page: {
          page: 1,
          size: 10
        }
      },
      value1: [],
      total: null,
      // 总条数
      tableData: [],
      loading: false,
      statusTypeDataIndex: 0,
      statusTypeData: [{
        name: '全部',
        id: 0
      }, {
        name: '今日',
        id: 1
      }, {
        name: '昨日',
        id: 2
      }, {
        name: '前天',
        id: 8
      }, {
        name: '近7天',
        id: 3
      }, {
        name: '近30天',
        id: 4
      }, {
        name: '近60天',
        id: 5
      }, {
        name: '自定义',
        id: 6
      }]
    };
  },
  mounted: function mounted() {
    this.value1 = [];
    this.queryData.page.page = 1;
    if (this.callbackQueryData) {
      if (this.callbackQueryData.queryOrderNo) {
        this.queryData.orderNo = this.callbackQueryData.queryOrderNo;
      }
      if (this.callbackQueryData.queryPlatform) {
        this.queryData.platform = this.callbackQueryData.queryPlatform;
      }
      if (this.callbackQueryData.queryStatus) {
        this.queryData.status = this.callbackQueryData.queryStatus;
      }
      if (this.callbackQueryData.queryViolate) {
        this.queryData.violate = this.callbackQueryData.queryViolate;
      }
    }
    console.log('12333333333--3');
    this.queryMemberOrderListApi();
  },
  methods: {
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(text) {
        var _this = this;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                this.$copyText(text).then(function () {
                  _this.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function copyText(_x) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    changeDataPicker: function changeDataPicker() {
      if (this.value1 === null) {
        this.value1 = [];
      }
      this.queryData.page.page = 1;
      this.queryMemberOrderListApi();
    },
    ObtainGetTime: function ObtainGetTime(num, num1) {
      return [this.$dayjs().subtract(num, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'), this.$dayjs().subtract(num1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    },
    onStatusList: function onStatusList(data) {
      this.statusTypeDataIndex = data.id;
      if (data.id === 0) {
        this.value1 = [];
      }
      if (data.id === 1) {
        this.value1 = this.ObtainGetTime(0, 0);
      }
      if (data.id === 2) {
        this.value1 = this.ObtainGetTime(1, 1);
      }
      if (data.id === 3) {
        this.value1 = this.ObtainGetTime(7, 0);
      }
      if (data.id === 4) {
        this.value1 = this.ObtainGetTime(30, 0);
      }
      if (data.id === 5) {
        this.value1 = this.ObtainGetTime(60, 0);
      }
      if (data.id === 7) {
        this.value1 = this.ObtainGetTime(90, 0);
      }
      if (data.id === 8) {
        this.value1 = this.ObtainGetTime(2, 2);
      }
      if (data.id === 6) {
        this.value1 = [];
        return false;
      }
      this.queryData.page.page = 1;
      this.queryMemberOrderListApi();
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryMemberOrderListApi();
    },
    // 重置
    onReset: function onReset() {
      this.statusTypeDataIndex = 0;
      this.value1 = [null, null];
      this.queryData = {
        type: 0,
        orderNo: '',
        platform: '',
        status: null,
        violate: null,
        page: {
          page: 1,
          size: 10
        }
      };
      this.queryMemberOrderListApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryMemberOrderListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryMemberOrderListApi();
    },
    queryMemberOrderListApi: function () {
      var _queryMemberOrderListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              params = (0, _objectSpread2.default)({
                memberId: this.memberId,
                startTime: this.value1.length > 0 ? this.value1[0] : null,
                endTime: this.value1.length > 0 ? this.value1[1] : null
              }, this.queryData);
              _context2.n = 2;
              return (0, _purchaseOrder.queryMemberOrderListApi)(params);
            case 2:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.log(_t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function queryMemberOrderListApi() {
        return _queryMemberOrderListApi2.apply(this, arguments);
      }
      return queryMemberOrderListApi;
    }(),
    handleClick: function handleClick(data) {
      this.$router.push({
        path: '/orderManagement/orderDetails',
        query: {
          orderNo: data.orderNo,
          unionCode: data.platform,
          // 传参
          JumpType: 'NeedReturn',
          type: 'self',
          queryOrderNo: this.queryData.orderNo,
          queryPlatform: this.queryData.platform,
          queryStatus: this.queryData.status,
          queryViolate: this.queryData.violate
        }
      });
    }
  }
};